export default "__VITE_ASSET__B2y3RDGe__"